import React, { useEffect, useContext, useState } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreateLeadPage from './LeadForms/CreateLead';
import CommunicationHistoryPage from './LeadForms/CommunicationHistory';
import Draggable from 'react-draggable';
import LeadService from "../Controller/LeadController";
import QuotationListPage from "../../Quotation/View/QuotationList";
import LeadDocumentListPage from "./LeadForms/LeadDocumentList";
import AppointmentListPage from "./LeadForms/AppointmentList";
import LeadReportPage from "./LeadForms/LeadReport";
import LeadUserDefineFields from "./LeadForms/LeadUserDefineFields";
import HelpSite from "../../Common/HelpLink";

function LeadDetail({ modalInstance, LeadID, onClose, onSuccess, IsDiaries, CommunicationID, onNext, onPrevious }) {

    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    const UserID = localStorage.getItem("UserID");
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [isMinimized, setIsMinimized] = useState(false);
    const [leadName, setLeadName] = useState("Lead Details");
    const [activeTab, setActiveTab] = useState(IsDiaries === "1" ? 'tab-comm' : 'tab-Lead');
    const [currentLeadID, setCurrentLeadID] = useState(LeadID);
    const [tabCount, setTabCount] = useState(0);
    const [isLock, setIsLock] = useState(0);
    const [Email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const [companyName, setCompany] = useState();
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {

        setCurrentLeadID(LeadID);
        setActiveTab(IsDiaries === "1" ? 'tab-comm' : 'tab-Lead');
        if (LeadID > 0) {
            fetchLeadDetail(LeadID);

        } else {
            setLeadName("Lead Details");
        }

    }, [LeadID]);
    const fetchLeadDetail = async (newLeadID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const LeadDetail = await LeadService.GetLeadByID(redirectCallback, newLeadID);
            setLeadName(LeadDetail[0].vc_Company); // Update this line to match your data structure
            setPhone(LeadDetail[0].vc_Phone);
            setMobile(LeadDetail[0].vc_Mobile);
            setEmail(LeadDetail[0].vc_Email)
            setCompany(LeadDetail[0].vc_Company)
            if (LeadDetail[0].isLock === 1 && LeadDetail[0].LockBy != UserID) {
                setIsLock(1);
            }
            else {
                setIsLock(0);
                await LeadService.LockLead(LeadID);
            }


        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };
    const handleSuccess = async () => {
        const newLeadID = parseInt(localStorage.getItem('LeadID'), 10);
        setCurrentLeadID(newLeadID);
        await fetchLeadDetail(newLeadID);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }


    let tabClass = (currentLeadID > 0) ? "nav-link" : "nav-link disabled";
    return (
        <div className="modal fade leadDetailModal show d-block" id="leadDetailModal" style={{ zIndex: "1050" }} tabIndex="-1" aria-labelledby="leadDetailModalLabel" aria-hidden="true" data-backdrop="static" data-bs-keyboard="false">

            <div className={`modal-dialog modal-xl`}>
                <Draggable handle=".modal-header" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{leadName && leadName.length > 30
                                ? `${leadName.substring(0, 30)}...`
                                : leadName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock === 0 ? "" : "(Locked)"}</strong> </h5>



                            <span>

                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize">
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} title='Details' style={{ background: "none", padding: "5px" }} className={`nav-link ${activeTab === 'tab-Lead' ? 'active' : ''}`} onClick={() => changeTab('tab-Lead')}
                                                    data-toggle="pill" href="#tab-Lead">
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/lead_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>

                                            </li>
                                            <li className="nav-item">
                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} title='Communication History' style={{ background: "none", padding: "5px" }} className={`nav-link ${tabClass} ${activeTab === 'tab-comm' ? 'active' : ''}`} data-toggle="pill" href="#tab-comm" onClick={() => changeTab('tab-comm')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/lead_comms-history.png" style={{ width: "25px", height: "25px" }} />

                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} title='Communication History' style={{ background: "none", padding: "5px" }} className={`nav-link ${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/lead_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} title='Documents' style={{ background: "none", padding: "5px" }} className={`nav-link ${tabClass} ${activeTab === 'tab-lead-document' ? 'active' : ''}`} data-toggle="pill" href="#tab-lead-document" onClick={() => changeTab('tab-lead-document')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/lead_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} title='Documents' style={{ background: "none", padding: "5px" }} className={`nav-link ${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/lead_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>

                                                )}
                                            </li>
                                            


                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-Lead" && (
                                                    <HelpSite FormName="Lead Detail" Module="33" />
                                            )}
                                            {activeTab === "tab-comm" && (
                                                <HelpSite FormName="Communication History" Module="33" />
                                            )}
                                            {activeTab === "tab-lead-document" && (
                                                <HelpSite FormName="Documents" Module="33" />
                                            )}
                                            {activeTab === "tab-lead-report" && (
                                                <HelpSite FormName="Report" Module="34" />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 pl-0">
                                    <div className="tab-content p-3" id="v-pills-tabContent">
                                        <div className={`tab-pane fade ${activeTab === 'tab-Lead' ? 'show active' : ''}`} id="tab-Lead" role="tabpanel">
                                            <CreateLeadPage LeadID={parseInt(currentLeadID, 10)} onSuccess={handleSuccess} Tab={tabCount} onNext={onNext} onPrevious={onPrevious} isLock={isLock} onClose={onClose} />
                                        </div>
                                        {currentLeadID > 0 && (
                                            <div className={`tab-pane fade ${activeTab === 'tab-comm' ? 'show active' : ''}`} id="tab-comm" role="tabpanel">

                                                <CommunicationHistoryPage LeadID={parseInt(currentLeadID, 10)} Tab={tabCount} IsDiaries={IsDiaries} CommunicationID={CommunicationID} isLock={isLock} Phone={phone} Mobile={mobile} CompanyName={companyName} ToEmail={Email} />
                                            </div>
                                        )}


                                        {currentLeadID > 0 && (
                                            <div className={`tab-pane fade ${activeTab === 'tab-lead-document' ? 'show active' : ''}`} id="tab-lead-document" role="tabpanel">
                                                <LeadDocumentListPage LeadID={parseInt(currentLeadID, 10)} isLock={isLock} Tab={tabCount} />
                                            </div>
                                        )}
                                        {currentLeadID > 0 && (
                                            <div className={`tab-pane fade ${activeTab === 'tab-lead-udf' ? 'show active' : ''}`} id="tab-lead-udf" role="tabpanel">
                                                <LeadUserDefineFields LeadID={parseInt(currentLeadID, 10)} isLock={isLock} Tab={tabCount} />
                                            </div>
                                        )}
                                        {currentLeadID > 0 && (
                                            <div className={`tab-pane fade ${activeTab === 'tab-lead-report' ? 'show active' : ''}`} id="tab-lead-report" role="tabpanel">
                                                <LeadReportPage LeadID={parseInt(currentLeadID, 10)} isLock={isLock} Tab={tabCount} />
                                            </div>
                                        )}


                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default LeadDetail;
